<!--<my-modal #approvalModal [useCustomFooter]="true" [classes]="['modal-lg']" (hideModal)="onApprovalModalHide()">-->
<!--  -->
<!--</my-modal>-->

<div class="dialog-header tw-flex tw-justify-between">
  <h2 mat-dialog-title class="!tw-mb-0">Edit Option</h2>
  <mat-icon class="close tw-cursor-pointer tw-m-4" aria-hidden="false" mat-dialog-close>close</mat-icon>
</div>

<mat-dialog-content>
  <div class="tw-text-lg tw-text-black tw-mb-1">{{ data?.option?.name }}</div>
  <div class="tw-text-sm tw-mb-2">{{ data?.optionParentName }}</div>
  <app-approval-smart
    *ngIf="initializeModalCalculator"
    [approvalsCount]="1"
    [approval]="data?.optionParent"
    [useStoreApprovals]="false"
    [hideHeader]="true"
    [editModalOverrideData]="editApprovalData"
    (calculationUpdate)="handleCalculationUpdate($event)"
  >
  </app-approval-smart>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="actions tw-px-4 tw-pb-4">
    <button
      mat-button
      mat-dialog-close
      class="btn btn-default tw-mr-2">
      Cancel
    </button>
    <button
      class="btn btn-primary"
      (click)="saveOption('approval')"
      [disabled]="false">
      Save
    </button>
  </div>
</mat-dialog-actions>
